import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Stack, Typography, CardContent, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { logout } from 'redux/slices/authSlice';
import { selectAuthenticated } from 'redux/slices/authSlice'
import Localization from 'hoc/localization';

import FullScreenLayout from 'components/layout/fullScreen/fullScreenLayout';
import FullScreenContentBody from 'components/layout/fullScreen/fullScreenContentBody';
import FullScreenCardTitle from 'components/layout/fullScreen/fullScreenCardTitle';
import FullScreenContentImgSection from 'components/layout/fullScreen/fullScreenContentImgSection';
import AnimatedLayout from "components/animationComponents/animatedLayout";
import AnimatedModule from 'components/animationComponents/animatedModule';
import AnimatedSection from 'components/animationComponents/animatedSection';

import api from './api';

const InfoSection = ({ handleClick, logoutCompleted, locale }) => {

  return (
    <CardContent sx={{ mt: (theme) => theme.spacing(3), mb: (theme) => theme.spacing(3), display: 'flex', flex: 1, alignItems: 'center' }}>
      <AnimatedSection sx={{ flex: 1 }}>
        <Stack>
          <FullScreenCardTitle title={locale.title} />
          <Typography mt={2} mb={2}>{logoutCompleted ? locale.completed : locale.loading}</Typography>
          <Button variant="contained" color="secondary"
            onClick={handleClick} disabled={!logoutCompleted} sx={{ mt: 3 }}
          > {locale.button} </Button>
        </Stack>
      </AnimatedSection>
    </CardContent>
  )
}


function Logout({ locale }) {
  const [logoutCompleted, setLogoutCompleted] = useState(false)
  const authenticated = useSelector(selectAuthenticated)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const redirectToLogin = () => navigate('/admission/login', { replace: true })

  useEffect(() => {
    if (!authenticated) return redirectToLogin()

    api.logout()
      .catch(() => { })
      .then(() => {
        setLogoutCompleted(true)
        dispatch(logout())
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AnimatedLayout>
      <FullScreenLayout >
        <AnimatedModule>
          <FullScreenContentBody>
            <Stack direction='row' spacing={0}>
              <InfoSection logoutCompleted={logoutCompleted} loading={!logoutCompleted} disabled={!logoutCompleted} handleClick={redirectToLogin} locale={locale} />
              <FullScreenContentImgSection />
            </Stack>
          </FullScreenContentBody>
        </AnimatedModule>
      </FullScreenLayout>
    </AnimatedLayout>
  );
}

export default Localization('Logout', Logout);